import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useChats = () => {
  const { baseUrl, userID, basicAuth } = useContext(GlobalContext);

  const [chats, setChats] = useState([]);
  const [loadingChats, setLoadingChats] = useState(false);

  const [people, setPeople] = useState([]); // users list
  const [labels, setLabels] = useState([]); // chat labels
  const [loading, setLoading] = useState(false);

  /* =============================
      FETCH CHAT CONVERSATION
  ============================= */
  const fetchChats = async (contact, pageIndex = 1) => {
    setLoadingChats(true);

    try {
      const res = await fetch(
        `${baseUrl}/Whatsapp/v1.0/getWhatsappConversation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: basicAuth,
          },
          body: JSON.stringify({
            userid: userID,
            contact: contact,
            secret: "",
            pageIndex: pageIndex.toString(),
            recordPerPage: "20",
          }),
        }
      );

      const data = await res.json();

      if (data?.data) {
        if (pageIndex === 1) {
          setChats([...data.data]);
        } else {
          setChats((prev) => [...data.data, ...prev]);
        }
      }

      return data;
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingChats(false);
    }
  };

  /* =============================
        SEND MESSAGE
  ============================= */
  const sendMessage = async (mobile, message) => {
    try {
      const res = await fetch(`${baseUrl}/Whatsapp/sendInstantMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: basicAuth,
        },
        body: JSON.stringify({
          userid: userID,
          message,
          contact: mobile,
          secret: "NA",
        }),
      });

      return await res.text();
    } catch (err) {
      console.error(err);
    }
  };

  /* =============================
      GET ALL USERS
  ============================= */
  const getAllUserList = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${baseUrl}/User/getAllUserList`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: basicAuth,
        },
        body: JSON.stringify({
          userid: userID,
        }),
      });

      const data = await res.json();

      if (data?.responseCode === "00") {
        setPeople(data.response);
      }

      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /* =============================
      GET CHAT LABELS
  ============================= */
  const fetchLabels = async () => {
    try {
      const res = await fetch(`${baseUrl}/Whatsapp/v1/getChatLabels`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: basicAuth,
        },
        body: JSON.stringify({
          userid: userID,
        }),
      });

      const result = await res.json();

      if (result?.data) {
        setLabels(result.data);
      }

      return result;
    } catch (error) {
      console.error("Error fetching labels:", error);
    }
  };

  /* =============================
      ASSIGN LABEL TO CHAT
  ============================= */
const assignLabelToChat = async (contactInfo, labelIndex) => {
  try {

    const Label = labels[labelIndex];

    const payload = {
      contactId: contactInfo.id,
      contactNumber: contactInfo.contact_number,
      userid: userID,
      label: Label
    };

    const res = await fetch(`${baseUrl}/Whatsapp/v1/assignLabelToChat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: basicAuth,
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    return data;

  } catch (error) {
    console.error("Assign Label Error:", error);
  }
};

  /* =============================
      ASSIGN TEAM MEMBER TO CHAT
  ============================= */
  const assignTeamMemberToChat = async (contactInfo, teamMemberId) => {
    try {
      const res = await fetch(
        `${baseUrl}/Whatsapp/v1/assignTeamMemberToChat`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: basicAuth,
          },
          body: JSON.stringify({
            contactId: contactInfo.id,
            teamMemberId: teamMemberId,
            userid: userID,
          }),
        }
      );

      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Assign Team Member Error:", error);
    }
  };

  /* =============================
      EDIT CONTACT
  ============================= */
  const editContact = async (payload) => {
    try {
      const res = await fetch(`${baseUrl}/Campaign/editContact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: basicAuth,
        },
        body: JSON.stringify({
          userid: userID,
          contactNumber: payload.contactNumber,
          contactName: payload.contactName,
          contactEmail: payload.contactEmail,
          gender: payload.gender,
          tags: payload.tags || [""],
        }),
      });

      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Edit Contact Error:", error);
    }
  };

  return {
    chats,
    loadingChats,
    fetchChats,
    sendMessage,

    /* dropdown data */
    people,
    setPeople,  
    labels,

    /* API calls */
    getAllUserList,
    fetchLabels,
    editContact,
    assignLabelToChat,
    assignTeamMemberToChat,

    loading,
  };
};

export default useChats;